/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Still_RunningInputs */

const cs_property_ai_still_running = /** @type {(inputs: Property_Ai_Still_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Může stále běžet na pozadí — za chvíli to zkontrolujte.`)
};

const en_property_ai_still_running = /** @type {(inputs: Property_Ai_Still_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This may still be running in the background — check again in a moment.`)
};

/**
* | output |
* | --- |
* | "This may still be running in the background — check again in a moment." |
*
* @param {Property_Ai_Still_RunningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_still_running = /** @type {((inputs?: Property_Ai_Still_RunningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Still_RunningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_still_running(inputs)
	return cs_property_ai_still_running(inputs)
});